import OrderRow from "./OrderRow";
import "../../styles/table.css";

export default function OrderTable({
  orders = [],
  onView,
  onAssign,
  setAssignTarget,
  onCancel,
}) {
  return (
    <div className="tableCard">
      <table className="modernTable">
        <thead>
          <tr>
            <th>Commande</th>
            <th>Statut</th>
            <th>Clients</th>
            <th>Chauffeur</th>
            <th>Montant</th>
            <th className="center">Actions</th>
          </tr>
        </thead>
        <tbody>
          {orders.map((order) => (
             <OrderRow
              key={order.id}
              order={order}
              onView={onView}
              onAssign={onAssign}
              onCancel={onCancel}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
}
